(() => {
  const controllers = new Map();
  function init(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController(), { signal } = controller;
    const toggle = root.querySelector('[data-top-toggle]'), panel = root.querySelector('[data-top-panel]');
    const mobile = matchMedia('(max-width:700px)');
    let open = false, inertElements = [];
    const actions = root.querySelector('.header-actions'), currencySlot = root.querySelector('[data-mobile-currency-slot]');
    const currency = actions?.querySelector('.header-language,.header-language-current');
    function placeCurrency() {
      if (!currency || !currencySlot) return;
      if (mobile.matches) currencySlot.append(currency);
      else actions.prepend(currency);
    }
    function release() {
      inertElements.forEach(([node, value]) => { node.inert = value; });
      inertElements = [];
      document.documentElement.classList.remove('top-nav-open');
    }
    function setOpen(value, focus = true) {
      open = value && mobile.matches;
      if (open) window.dispatchEvent(new CustomEvent('saguaro:top-nav-open'));
      toggle.setAttribute('aria-expanded', String(open));
      panel.classList.toggle('is-open', open);
      panel.inert = mobile.matches && !open;
      release();
      if (open) {
        panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-label', toggle.getAttribute('aria-label'));
        document.documentElement.classList.add('top-nav-open');
        for (const node of document.querySelectorAll('#MainContent,.shopify-section-group-footer-group,[data-logo-menu]')) {
          inertElements.push([node, node.inert]); node.inert = true;
        }
        if (focus) panel.querySelector('button,a,select')?.focus();
      } else {
        panel.removeAttribute('role'); panel.removeAttribute('aria-modal');
        if (focus && mobile.matches) toggle.focus();
      }
    }
    root.classList.add('is-enhanced');
    toggle.addEventListener('click', () => setOpen(!open), { signal });
    root.querySelector('[data-top-close]').addEventListener('click', () => setOpen(false), { signal });
    root.addEventListener('change', e => { if (e.target.matches('[data-market-select]')) e.target.form.requestSubmit(); }, { signal });
    root.addEventListener('keydown', e => {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); setOpen(false); }
      if (e.key === 'Tab') {
        const items = [...panel.querySelectorAll('a,button,select')].filter(el => !el.disabled && el.getClientRects().length);
        const first = items[0], last = items.at(-1);
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }, { signal });
    window.addEventListener('saguaro:logo-nav-open', () => { if (open) setOpen(false, false); }, { signal });
    mobile.addEventListener('change', () => { placeCurrency(); setOpen(false, false); }, { signal });
    function contrast() {
      const hero = document.querySelector('.hero.m01-carousel');
      const config = document.querySelector('[data-mobile-navigation-settings]');
      const threshold = Number(config?.dataset.scrollThreshold ?? 50);
      const solid = !hero || (mobile.matches && config ? window.scrollY >= threshold : hero.getBoundingClientRect().bottom <= 84);
      root.classList.toggle('is-solid', solid);
    }
    window.addEventListener('scroll', contrast, { passive: true, signal });
    window.addEventListener('resize', contrast, { passive: true, signal });
    document.addEventListener('shopify:section:load', contrast, { signal });
    document.addEventListener('shopify:section:reorder', contrast, { signal });
    document.addEventListener('shopify:section:unload', () => requestAnimationFrame(() => { if (!signal.aborted) contrast(); }), { signal });
    placeCurrency(); setOpen(false, false); contrast();
    controllers.set(root, () => { release(); controller.abort(); });
  }
  function boot(scope) { scope.querySelectorAll('[data-top-navigation]').forEach(init); }
  boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
  document.addEventListener('shopify:section:unload', e => {
    for (const [root, dispose] of controllers) if (e.target.contains(root)) { dispose(); controllers.delete(root); }
  });
})();
